export default __webpack_public_path__ + "static/media/RaghuDixit.4d3c9298.jpg";